import { Extension, Node } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    readonlyText: {
      insertReadonlyText: (text: string, style?: string) => ReturnType;
    };
  }
}

const ReadonlyTextNode = Node.create({
  name: 'readonlyTextNode',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      text: {
        default: '',
      },
      style: {
        default: '',
      },
    }
  },

  parseHTML() {
    return [
      { 
        tag: 'span[data-readonly-text="true"]',
        getAttrs: (element) => {
          const text = element.textContent || '';
          const style = element.getAttribute('style') || '';
          return { text, style };
        }
      },
      { 
        tag: 'span',
        getAttrs: (element) => {
          const hasReadonlyAttr = element.getAttribute('data-readonly-text') === 'true';
          const hasReadonlyStyle = element.getAttribute('style')?.includes('user-select: none');
          
          if (hasReadonlyAttr || hasReadonlyStyle) {
            const text = element.textContent || '';
            const style = element.getAttribute('style') || '';
            return { text, style };
          }
          return false;
        }
      },
    ]
  },

  renderHTML({ node }) {
    const baseStyle = 'user-select: none; pointer-events: none; cursor: default;';
    const customStyle = node.attrs.style || '';
    
    return ['span', { 
      'data-readonly-text': 'true',
      style: `${baseStyle} ${customStyle}`.trim()
    }, node.attrs.text]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('span');
      dom.contentEditable = 'false';
      dom.innerText = node.attrs.text;
      dom.style.userSelect = 'none';
      dom.style.pointerEvents = 'none';
      dom.style.cursor = 'default';
      
      if (node.attrs.style) {
        dom.style.cssText += node.attrs.style;
      }
      
      dom.setAttribute('data-readonly-text', 'true');
      return { dom };
    };
  },
});

export const ReadonlyTextExtension = Extension.create({
  name: 'readonlyText',

  addExtensions() {
    return [
      ReadonlyTextNode,
    ]
  },

  addCommands() {
    return {
      insertReadonlyText:
        (text: string, style: string = '') =>
        ({ commands }) => {
          return commands.insertContent({
            type: 'readonlyTextNode',
            attrs: { text, style },
          });
        },
    };
  },
});
